module.exports = __webpack_public_path__ + "img/features-bg_18.ff947a94.png";